import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { translate } from 'react-i18next';

import OutageNotificationDetail from './outageNotificationDetail';
import { getRowById } from '../../reducers/tableReducer';
import { navigateToOutageNotifications } from '../../actions/navigationActions';
import { createOutageNotification, updateOutageNotification } from '../../actions/outageNotificationActions';
import OutageNotification from '../../entities/outageNotification';
import { BaseDetailDispatchProps, BaseDetailProps } from '../common/types/baseDetail';

interface OutageNotificationDetailUpdateProps extends BaseDetailProps<OutageNotification> {}

const OutageNotificationDetailUpdate = ({ initialValues, submitAction, cancelAction, t }: OutageNotificationDetailUpdateProps) => {
    return (
        <OutageNotificationDetail
            t={t}
            initialValues={initialValues}
            submitAction={submitAction}
            headerText={t('CreateOutageNotification')}
            cancelAction={cancelAction}
        />
    );
};

const mapStateToProps = (state: any, { match }: any) => {
    const id = match.params.id;

    return {
        lang: state.app.lang,
        initialValues: getRowById(state, id),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): BaseDetailDispatchProps<OutageNotification> => {
    return {
        submitAction: bindActionCreators(updateOutageNotification, dispatch),
        cancelAction: bindActionCreators(navigateToOutageNotifications, dispatch),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate('common'))(OutageNotificationDetailUpdate);
